import {Action} from '@ngrx/store';
import {DynSelectFieldOptions} from '../domain/meta/fields/select/dyn-select-field-options';

export const CREATE             = '[SelectFieldOptions] Create';
export const CREATE_SUCCESS     = '[SelectFieldOptions] CreateSuccess';
export const CREATE_FAIL        = '[SelectFieldOptions] CreateFail';
export const UPDATE             = '[SelectFieldOptions] Update';
export const UPDATE_SUCCESS     = '[SelectFieldOptions] UpdateSuccess';
export const UPDATE_FAIL        = '[SelectFieldOptions] UpdateFail';
export const DELETE             = '[SelectFieldOptions] Delete';
export const DELETE_SUCCESS     = '[SelectFieldOptions] DeleteSuccess';
export const DELETE_FAIL        = '[SelectFieldOptions] DeleteFail';
export const LOAD_ALL           = '[SelectFieldOptions] LoadAll';
export const LOAD_ALL_SUCCESS   = '[SelectFieldOptions] LoadAllSuccess';
export const LOAD_ALL_FAIL      = '[SelectFieldOptions] LoadALlFail';
export const ERROR              = '[SelectFieldOptions] Error';

export class Create implements Action {
    readonly type = CREATE;
    constructor(public options: DynSelectFieldOptions<any>) { }
}

export class CreateSuccess implements Action {
    readonly type = CREATE_SUCCESS;
    constructor(public options: DynSelectFieldOptions<any>) { }
}

export class CreateFail implements Action {
    readonly type = CREATE_FAIL;
    constructor(public error: string) { }
}

export class Update implements Action {
    readonly type = UPDATE;
    constructor(public options: DynSelectFieldOptions<any>) { }
}

export class UpdateSuccess implements Action {
    readonly type = UPDATE_SUCCESS;
    constructor(
        public id: number,
        public changes: Partial<DynSelectFieldOptions<any>>
    ) { }
}

export class UpdateFail implements Action {
    readonly type = UPDATE_FAIL;
    constructor(public error: string) { }
}

export class Delete implements Action {
    readonly type = DELETE;
    constructor(public id: number) { }
}

export class DeleteSuccess implements Action {
    readonly type = DELETE_SUCCESS;
    constructor(public id: number) { }
}

export class DeleteFail implements Action {
    readonly type = DELETE_FAIL;
    constructor(public error: string) { }
}

export class LoadAll implements Action {
    readonly type = LOAD_ALL;
    constructor() { }
}

export class LoadAllSuccess implements Action {
    readonly type = LOAD_ALL_SUCCESS;
    constructor(public options: DynSelectFieldOptions<any>[]) { }
}

export class LoadAllFail implements Action {
    readonly type = LOAD_ALL_FAIL;
    constructor(public error: string) { }
}

export type SelectFieldOptionsActions
    = Create
    | CreateSuccess
    | CreateFail
    | Update
    | UpdateSuccess
    | UpdateFail
    | Delete
    | DeleteSuccess
    | DeleteFail
    | LoadAll
    | LoadAllSuccess
    | LoadAllFail;



// WEBPACK FOOTER //
// ./src/app/forms/state/select-field-options.actions.ts